// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__Q3esg","actions":"GroupTable_actions__3uleH","deleteModalFooter":"GroupTable_deleteModalFooter__1e5Hn"};